import React from "react"
import { Col, Dropdown, Row } from "react-bootstrap"
import { ChevronDown, ChevronUp } from "react-bootstrap-icons"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
import { useTranslation } from "react-i18next"
import { SuiteModel } from "../../api/suite.api"
import aramex from "../../assets/ShippingCompaniesIcons/aramex.svg"
import dhl from "../../assets/ShippingCompaniesIcons/dhl.svg"
import fedex from "../../assets/ShippingCompaniesIcons/fedex.svg"
import shopini from "../../assets/ShippingCompaniesIcons/shopini-economy.svg"
import ups from "../../assets/ShippingCompaniesIcons/ups.svg"
import usps from "../../assets/ShippingCompaniesIcons/usps.svg"
import { CustomSearchBar, SelectFilterColums } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import RemotePagination from "../../components/Tables/RemotePagination"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
function SuitesTable({
    search,
    status,
    suites,
    tableDataChange,
    serachDetailChange
}: {
    search: string
    status: string
    suites: SuiteModel
    tableDataChange: Function
    serachDetailChange: Function
}) {
    const { t } = useTranslation()

    const handleTableChange = (type: any, { page, sizePerPage }: { page: number; sizePerPage: number }) => {
        tableDataChange(page, sizePerPage)
    }

    const onSearchData = (value: string) => {
        serachDetailChange(value, status)
    }
    const onFilterData = (value: string) => {
        serachDetailChange(search, value)
    }

    const handleClick = (buttonId: any) => {
        const actionbtn = document.querySelector(buttonId) as HTMLElement
        if (actionbtn) actionbtn.click()
    }
    //TODO create ParcelItemsModel
    function getParcelsItems(cell: Record<string, any>[]) {
        let quantity = 0
        cell?.forEach((ParcelSuites: Record<string, any>) => {
            ;(ParcelSuites?.parcel?.ParcelItems || [])?.forEach((parcelItem: Record<string, any>) => {
                quantity += parcelItem?.quantity || 0
            })
        })
        return quantity
    }

    const onExternalClickLink = (id: string, type: string) => {
        let url = type === "barcode" ? GLOBAL_CONSTANTS.SUITE_BARCODE_DOWNLOAD_URL + id : ""
        window.open(url, "_blank")
    }

    const columns = [
        {
            text: t("Suite_Id"),
            dataField: "suite",
            classes: "highlighted-text"
        },
        {
            text: t("Parcels"),
            dataField: "ParcelSuites.length"
        },
        {
            text: t("Items"),
            dataField: "ParcelSuites",
            formatter: (cell: Record<string, any>[]) => {
                return getParcelsItems(cell)
            },
            csvFormatter: (cell: Record<string, any>[]) => {
                return getParcelsItems(cell)
            }
        },
        {
            text: t("User_Id"),
            dataField: "UserSuite.user.user_pin",
            formatter: (cell: string | number, row: Record<string, any>) => {
                return (
                    <div>
                        <span className="d-flex">{cell}</span>
                        <span>{row.UserSuite?.user?.name}</span>
                    </div>
                )
            },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell + " ," + row.UserSuite?.user?.name : ""
            }
        },
        {
            dataField: "",
            text: t("Actions"),
            csvExport: false,
            formatter: (cell: number, row: Record<string, any>) => {
                return (
                    <Dropdown className="actions-menu">
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" size={"sm"} className="py-0">
                            {t("Actions")}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {["Export Excel", "Print Barcode"].map((action) => (
                                <Dropdown.Item className="py-0">
                                    {action === "Export Excel" && (
                                        <div onClick={() => handleClick(".suitesInnerExportButton")}>
                                            {action}
                                        </div>
                                    )}
                                    {action === "Print Barcode" && (
                                        <div onClick={() => onExternalClickLink(row.suite, "barcode")}>
                                            {action}
                                        </div>
                                    )}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )
            }
        },
        {
            text: t("Parcel_Detail"),
            dataField: "id",
            hidden: true,
            csvText: t("Parcel_Detail"),
            csvFormatter: (cell: number, row: Record<string, any>) => {
                let parcelData = ""
                row.ParcelSuites?.forEach((ParcelSuite: Record<string, any>, index: number) => {
                    if (ParcelSuite.parcel) {
                        const uuid = ParcelSuite?.parcel?.uuid ? ParcelSuite.parcel.uuid + "," : ""
                        const parcelQuantity = ParcelSuite?.parcel?.ParcelHasItems
                            ? ParcelSuite?.parcel?.ParcelHasItems?.length + ","
                            : 0
                        const companyName = ParcelSuite?.parcel?.ShippingCompany
                            ? ParcelSuite.parcel.ShippingCompany.shipping_name
                            : ""
                        parcelData += uuid + parcelQuantity + companyName
                        if (index < row.ParcelSuites?.length - 1) parcelData += " :: "
                    }
                })
                return parcelData
            }
        }
    ]

    const expandRow = {
        renderer: (row: Record<string, any>) => {
            const columns = [
                {
                    text: t("Parcel_Uuid"),
                    dataField: "parcel.uuid",
                    classes: "highlighted-text"
                },
                {
                    text: t("Item"),
                    dataField: "parcel.ParcelItems",
                    formatter: (cell: [], row: number) => {
                        let quantity = 0
                        cell.forEach((parcelItem: Record<string, any>) => {
                            quantity += parcelItem?.quantity || 0
                        })
                        return quantity
                    },
                    csvFormatter: (cell: [], row: Record<string, any>) => {
                        let quantity = 0
                        cell.forEach((parcelItem: Record<string, any>) => {
                            quantity += parcelItem?.quantity || 0
                        })
                        return quantity
                    }
                },
                {
                    text: t("Shipping_Company"),
                    dataField: "parcel.ParcelPayment.ShippingCompany",
                    formatter: (cell: any, row: Record<string, any>) => {
                        let imageSrc = row?.shipping_name
                        if (cell?.logo.match("aramex")) imageSrc = aramex
                        if (cell?.logo.match("dhl")) imageSrc = dhl
                        if (cell?.logo.match("FedEx")) imageSrc = fedex
                        if (cell?.logo.match("usps")) imageSrc = usps
                        if (cell?.logo.match("shopini")) imageSrc = shopini
                        if (cell?.logo.match("ups")) imageSrc = ups
                        return cell ? (
                            <div className="d-flex">
                                <img width="100" height="60" src={imageSrc} alt="shipping_company" />
                                <div className="my-auto mx-3">{cell.shipping_name}</div>
                            </div>
                        ) : (
                            ""
                        )
                    },
                    csvFormatter: (cell: any, row: Record<string, any>) => {
                        return cell ? cell?.shipping_name : ""
                    }
                }
            ]
            let totalParcels = row?.ParcelSuites.length
            return (
                <ToolkitProvider
                    keyField="id"
                    data={row?.ParcelSuites}
                    columns={columns}
                    exportCSV={{
                        fileName: "SuitesParcelTable.csv"
                    }}>
                    {(props) => (
                        <div>
                            <ExportCSVButton className="suitesInnerExportButton d-none" {...props.csvProps}>
                                Export CSV!!
                            </ExportCSVButton>
                            <div className="heading my-3 mx-4">
                                {totalParcels > 1
                                    ? totalParcels + " " + t("multiple_parcels")
                                    : totalParcels === 1
                                      ? totalParcels + " " + t("single_parcel")
                                      : ""}
                            </div>
                            <BootstrapTable
                                wrapperClasses="inner-table my-3 mx-4 "
                                headerClasses="header-class"
                                bordered={false}
                                noDataIndication={t("No_Record")}
                                rowClasses="inner-table-row"
                                condensed={true}
                                {...props.baseProps}
                            />
                        </div>
                    )}
                </ToolkitProvider>
            )
        },
        showExpandColumn: true,
        onlyOneExpanding: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return <></>
        },
        expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
            if (expanded) {
                return <ChevronUp color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
            }
            return <ChevronDown color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
        }
    }

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {columns && (
                <ToolkitProvider
                    keyField="id"
                    data={suites?.suites || []}
                    columns={columns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "SuitesTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search mx-2  suites-search">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <SelectFilterColums
                                        preFilteredRows={props.baseProps.data}
                                        id="active"
                                        text={t("Status")}
                                        {...props.searchProps}
                                        onFilterClick={onFilterData}
                                        table="suite"
                                        activeFilter={status}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={6} className="px-4 search-col">
                                    <CustomSearchBar
                                        inputVal={search}
                                        {...props.searchProps}
                                        onSearchData={onSearchData}
                                    />
                                    <ExportCSVButton {...props.csvProps} className=" suitesExportButton d-none">
                                        Export
                                    </ExportCSVButton>
                                </Col>
                            </Row>
                            <Row className="table-data my-3">
                                <Col>
                                    {suites?.suites?.length > 0 && (
                                        <RemotePagination
                                            data={suites?.suites}
                                            page={suites?.page}
                                            sizePerPage={suites?.page_size}
                                            totalSize={suites?.total}
                                            onTableChange={handleTableChange}
                                            columns={columns}
                                            keyField="uuid"
                                            expandRow={expandRow}
                                            props={props}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default SuitesTable
